
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {DaysOfWeek} from './DaysOfWeek';
import {FieldModelDaysOfWeek} from './DaysOfWeek';

/**
 * TradingCalendarRegularRule struct
 */
class TradingCalendarRegularRule {
  /**
   * Initialize struct
   * @param {!UUID=} id
   * @param {!string=} name
   * @param {!DaysOfWeek=} days
   * @param {!Array=} symbolNames
   * @param {!Array=} symbolGroupNames
   * @param {!boolean=} isDefault
   * @param {!number=} marketOpen
   * @param {!number=} marketClose
   * @param {!number=} tradeOpen
   * @param {!number=} tradeClose
   * @param {!string=} comment
   * @param {!Array=} offTimeRulesIds
   * @param {!UUID=} timezoneId
   * @constructor
   */
  constructor (id = UUID.sequential(), name = '', days = new DaysOfWeek(), symbolNames = [], symbolGroupNames = [], isDefault = false, marketOpen = new UInt64(0, 0), marketClose = new UInt64(0, 0), tradeOpen = new UInt64(0, 0), tradeClose = new UInt64(0, 0), comment = '', offTimeRulesIds = [], timezoneId = new UUID()) {
    this.id = id
    this.Name = name
    this.Days = days
    this.SymbolNames = symbolNames
    this.SymbolGroupNames = symbolGroupNames
    this.IsDefault = isDefault
    this.MarketOpen = marketOpen
    this.MarketClose = marketClose
    this.TradeOpen = tradeOpen
    this.TradeClose = tradeClose
    this.Comment = comment
    this.OffTimeRulesIds = offTimeRulesIds
    this.TimezoneId = timezoneId
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradingCalendarRegularRule}
   * @param {!TradingCalendarRegularRule} other Other struct
   * @returns {!TradingCalendarRegularRule} This struct
   */
  copy (other) {
    if (other.id != null) {
      this.id = new UUID(other.id)
    } else {
      this.id = null
    }
    if (other.Name != null) {
      this.Name = other.Name
    } else {
      this.Name = null
    }
    if (other.Days != null) {
      this.Days = DaysOfWeek.fromObject(other.Days)
    } else {
      this.Days = null
    }
    if (other.SymbolNames != null) {
      this.SymbolNames = []
      for (let item of other.SymbolNames) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.SymbolNames.push(tempItem)
        } else {
          this.SymbolNames.push(null)
        }
      }
    } else {
      this.SymbolNames = null
    }
    if (other.SymbolGroupNames != null) {
      this.SymbolGroupNames = []
      for (let item of other.SymbolGroupNames) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.SymbolGroupNames.push(tempItem)
        } else {
          this.SymbolGroupNames.push(null)
        }
      }
    } else {
      this.SymbolGroupNames = null
    }
    if (other.IsDefault != null) {
      this.IsDefault = other.IsDefault
    } else {
      this.IsDefault = null
    }
    if (other.MarketOpen != null) {
      this.MarketOpen = UInt64.fromNumber(other.MarketOpen)
    } else {
      this.MarketOpen = null
    }
    if (other.MarketClose != null) {
      this.MarketClose = UInt64.fromNumber(other.MarketClose)
    } else {
      this.MarketClose = null
    }
    if (other.TradeOpen != null) {
      this.TradeOpen = UInt64.fromNumber(other.TradeOpen)
    } else {
      this.TradeOpen = null
    }
    if (other.TradeClose != null) {
      this.TradeClose = UInt64.fromNumber(other.TradeClose)
    } else {
      this.TradeClose = null
    }
    if (other.Comment != null) {
      this.Comment = other.Comment
    } else {
      this.Comment = null
    }
    if (other.OffTimeRulesIds != null) {
      this.OffTimeRulesIds = []
      for (let item of other.OffTimeRulesIds) {
        if (item != null) {
          let tempItem
          tempItem = new UUID(item)
          this.OffTimeRulesIds.push(tempItem)
        } else {
          this.OffTimeRulesIds.push(null)
        }
      }
    } else {
      this.OffTimeRulesIds = null
    }
    if (other.TimezoneId != null) {
      this.TimezoneId = new UUID(other.TimezoneId)
    } else {
      this.TimezoneId = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradingCalendarRegularRule}
   * @returns {!TradingCalendarRegularRule} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradingCalendarRegularRuleModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradingCalendarRegularRuleModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradingCalendarRegularRule}
   * @param {!TradingCalendarRegularRule} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradingCalendarRegularRule)) {
      throw new TypeError('Instance of TradingCalendarRegularRule is required!')
    }
    // noinspection RedundantIfStatementJS
    if (this.id != null) {
      if ((other.id == null) || !this.id.eq(other.id)) {
        return false
      }
    } else if (other.id != null) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradingCalendarRegularRule}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      id: ((this.id != null) ? this.id.toString() : null),
      Name: ((this.Name != null) ? this.Name : null),
      Days: ((this.Days != null) ? this.Days : null),
      SymbolNames: ((this.SymbolNames != null) ? Array.from(this.SymbolNames, item => ((item != null) ? item : null)) : null),
      SymbolGroupNames: ((this.SymbolGroupNames != null) ? Array.from(this.SymbolGroupNames, item => ((item != null) ? item : null)) : null),
      IsDefault: ((this.IsDefault != null) ? this.IsDefault : null),
      MarketOpen: ((this.MarketOpen != null) ? this.MarketOpen.toNumber() : null),
      MarketClose: ((this.MarketClose != null) ? this.MarketClose.toNumber() : null),
      TradeOpen: ((this.TradeOpen != null) ? this.TradeOpen.toNumber() : null),
      TradeClose: ((this.TradeClose != null) ? this.TradeClose.toNumber() : null),
      Comment: ((this.Comment != null) ? this.Comment : null),
      OffTimeRulesIds: ((this.OffTimeRulesIds != null) ? Array.from(this.OffTimeRulesIds, item => ((item != null) ? item.toString() : null)) : null),
      TimezoneId: ((this.TimezoneId != null) ? this.TimezoneId.toString() : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradingCalendarRegularRule.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradingCalendarRegularRule} other Object value
   * @returns {!TradingCalendarRegularRule} Created struct
   */
  static fromObject (other) {
    return new TradingCalendarRegularRule().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradingCalendarRegularRule}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradingCalendarRegularRule.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradingCalendarRegularRule}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 59
  }
}

export { TradingCalendarRegularRule };

/**
 * Fast Binary Encoding TradingCalendarRegularRule field model
 */
class FieldModelTradingCalendarRegularRule extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.id = new fbe.FieldModelUUID(buffer, 4 + 4)
    this.Name = new fbe.FieldModelString(buffer, this.id.fbeOffset + this.id.fbeSize)
    this.Days = new FieldModelDaysOfWeek(buffer, this.Name.fbeOffset + this.Name.fbeSize)
    this.SymbolNames = new fbe.FieldModelVector(new fbe.FieldModelString(buffer, this.Days.fbeOffset + this.Days.fbeSize), buffer, this.Days.fbeOffset + this.Days.fbeSize)
    this.SymbolGroupNames = new fbe.FieldModelVector(new fbe.FieldModelString(buffer, this.SymbolNames.fbeOffset + this.SymbolNames.fbeSize), buffer, this.SymbolNames.fbeOffset + this.SymbolNames.fbeSize)
    this.IsDefault = new fbe.FieldModelBool(buffer, this.SymbolGroupNames.fbeOffset + this.SymbolGroupNames.fbeSize)
    this.MarketOpen = new fbe.FieldModelUInt64(buffer, this.IsDefault.fbeOffset + this.IsDefault.fbeSize)
    this.MarketClose = new fbe.FieldModelUInt64(buffer, this.MarketOpen.fbeOffset + this.MarketOpen.fbeSize)
    this.TradeOpen = new fbe.FieldModelUInt64(buffer, this.MarketClose.fbeOffset + this.MarketClose.fbeSize)
    this.TradeClose = new fbe.FieldModelUInt64(buffer, this.TradeOpen.fbeOffset + this.TradeOpen.fbeSize)
    this.Comment = new fbe.FieldModelString(buffer, this.TradeClose.fbeOffset + this.TradeClose.fbeSize)
    this.OffTimeRulesIds = new fbe.FieldModelVector(new fbe.FieldModelUUID(buffer, this.Comment.fbeOffset + this.Comment.fbeSize), buffer, this.Comment.fbeOffset + this.Comment.fbeSize)
    this.TimezoneId = new fbe.FieldModelUUID(buffer, this.OffTimeRulesIds.fbeOffset + this.OffTimeRulesIds.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelTradingCalendarRegularRule}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradingCalendarRegularRule}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.id.fbeSize + this.Name.fbeSize + this.Days.fbeSize + this.SymbolNames.fbeSize + this.SymbolGroupNames.fbeSize + this.IsDefault.fbeSize + this.MarketOpen.fbeSize + this.MarketClose.fbeSize + this.TradeOpen.fbeSize + this.TradeClose.fbeSize + this.Comment.fbeSize + this.OffTimeRulesIds.fbeSize + this.TimezoneId.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradingCalendarRegularRule}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.id.fbeExtra + this.Name.fbeExtra + this.Days.fbeExtra + this.SymbolNames.fbeExtra + this.SymbolGroupNames.fbeExtra + this.IsDefault.fbeExtra + this.MarketOpen.fbeExtra + this.MarketClose.fbeExtra + this.TradeOpen.fbeExtra + this.TradeClose.fbeExtra + this.Comment.fbeExtra + this.OffTimeRulesIds.fbeExtra + this.TimezoneId.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradingCalendarRegularRule}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradingCalendarRegularRule.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradingCalendarRegularRule}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 59
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradingCalendarRegularRule}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradingCalendarRegularRule}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.id.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.id.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.id.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Name.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Days.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Days.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Days.fbeSize

    if ((fbeCurrentSize + this.SymbolNames.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolNames.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolNames.fbeSize

    if ((fbeCurrentSize + this.SymbolGroupNames.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolGroupNames.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupNames.fbeSize

    if ((fbeCurrentSize + this.IsDefault.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsDefault.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsDefault.fbeSize

    if ((fbeCurrentSize + this.MarketOpen.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarketOpen.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarketOpen.fbeSize

    if ((fbeCurrentSize + this.MarketClose.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarketClose.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarketClose.fbeSize

    if ((fbeCurrentSize + this.TradeOpen.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradeOpen.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeOpen.fbeSize

    if ((fbeCurrentSize + this.TradeClose.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradeClose.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeClose.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Comment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.OffTimeRulesIds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OffTimeRulesIds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OffTimeRulesIds.fbeSize

    if ((fbeCurrentSize + this.TimezoneId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TimezoneId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TimezoneId.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradingCalendarRegularRule}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradingCalendarRegularRule}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradingCalendarRegularRule}
   * @param {!TradingCalendarRegularRule} fbeValue Default value, defaults is new TradingCalendarRegularRule()
   * @returns {!TradingCalendarRegularRule} TradingCalendarRegularRule value
   */
  get (fbeValue = new TradingCalendarRegularRule()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradingCalendarRegularRule}
   * @param {!TradingCalendarRegularRule} fbeValue TradingCalendarRegularRule value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.id.fbeSize) <= fbeStructSize) {
      fbeValue.id = this.id.get(UUID.sequential())
    } else {
      fbeValue.id = UUID.sequential()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.id.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) <= fbeStructSize) {
      fbeValue.Name = this.Name.get()
    } else {
      fbeValue.Name = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Days.fbeSize) <= fbeStructSize) {
      fbeValue.Days = this.Days.get()
    } else {
      fbeValue.Days = new DaysOfWeek()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Days.fbeSize

    if ((fbeCurrentSize + this.SymbolNames.fbeSize) <= fbeStructSize) {
      this.SymbolNames.get(fbeValue.SymbolNames)
    } else {
      fbeValue.SymbolNames.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolNames.fbeSize

    if ((fbeCurrentSize + this.SymbolGroupNames.fbeSize) <= fbeStructSize) {
      this.SymbolGroupNames.get(fbeValue.SymbolGroupNames)
    } else {
      fbeValue.SymbolGroupNames.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupNames.fbeSize

    if ((fbeCurrentSize + this.IsDefault.fbeSize) <= fbeStructSize) {
      fbeValue.IsDefault = this.IsDefault.get()
    } else {
      fbeValue.IsDefault = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsDefault.fbeSize

    if ((fbeCurrentSize + this.MarketOpen.fbeSize) <= fbeStructSize) {
      fbeValue.MarketOpen = this.MarketOpen.get()
    } else {
      fbeValue.MarketOpen = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarketOpen.fbeSize

    if ((fbeCurrentSize + this.MarketClose.fbeSize) <= fbeStructSize) {
      fbeValue.MarketClose = this.MarketClose.get()
    } else {
      fbeValue.MarketClose = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarketClose.fbeSize

    if ((fbeCurrentSize + this.TradeOpen.fbeSize) <= fbeStructSize) {
      fbeValue.TradeOpen = this.TradeOpen.get()
    } else {
      fbeValue.TradeOpen = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeOpen.fbeSize

    if ((fbeCurrentSize + this.TradeClose.fbeSize) <= fbeStructSize) {
      fbeValue.TradeClose = this.TradeClose.get()
    } else {
      fbeValue.TradeClose = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeClose.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) <= fbeStructSize) {
      fbeValue.Comment = this.Comment.get()
    } else {
      fbeValue.Comment = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.OffTimeRulesIds.fbeSize) <= fbeStructSize) {
      this.OffTimeRulesIds.get(fbeValue.OffTimeRulesIds)
    } else {
      fbeValue.OffTimeRulesIds.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OffTimeRulesIds.fbeSize

    if ((fbeCurrentSize + this.TimezoneId.fbeSize) <= fbeStructSize) {
      fbeValue.TimezoneId = this.TimezoneId.get()
    } else {
      fbeValue.TimezoneId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TimezoneId.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradingCalendarRegularRule}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradingCalendarRegularRule}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradingCalendarRegularRule}
   * @param {!TradingCalendarRegularRule} fbeValue TradingCalendarRegularRule value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradingCalendarRegularRule}
   * @param {TradingCalendarRegularRule} fbeValue TradingCalendarRegularRule value
   */
  setFields (fbeValue) {
    this.id.set(fbeValue.id)
    this.Name.set(fbeValue.Name)
    this.Days.set(fbeValue.Days)
    this.SymbolNames.set(fbeValue.SymbolNames)
    this.SymbolGroupNames.set(fbeValue.SymbolGroupNames)
    this.IsDefault.set(fbeValue.IsDefault)
    this.MarketOpen.set(fbeValue.MarketOpen)
    this.MarketClose.set(fbeValue.MarketClose)
    this.TradeOpen.set(fbeValue.TradeOpen)
    this.TradeClose.set(fbeValue.TradeClose)
    this.Comment.set(fbeValue.Comment)
    this.OffTimeRulesIds.set(fbeValue.OffTimeRulesIds)
    this.TimezoneId.set(fbeValue.TimezoneId)
  }
}

export { FieldModelTradingCalendarRegularRule };

/**
 * Fast Binary Encoding TradingCalendarRegularRule model
 */
class TradingCalendarRegularRuleModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradingCalendarRegularRule(this.buffer, 4)
  }

  /**
   * Get the TradingCalendarRegularRule model
   * @this {!TradingCalendarRegularRuleModel}
   * @returns {!FieldModelTradingCalendarRegularRule} model TradingCalendarRegularRule model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradingCalendarRegularRuleModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradingCalendarRegularRuleModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradingCalendarRegularRuleModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradingCalendarRegularRuleModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradingCalendarRegularRule.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradingCalendarRegularRuleModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradingCalendarRegularRuleModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradingCalendarRegularRuleModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradingCalendarRegularRuleModel}
   * @param {!TradingCalendarRegularRule} value TradingCalendarRegularRule value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradingCalendarRegularRuleModel}
   * @param {!TradingCalendarRegularRule} value TradingCalendarRegularRule value, defaults is new TradingCalendarRegularRule()
   * @return {!object} Deserialized TradingCalendarRegularRule value and its size
   */
  deserialize (value = new TradingCalendarRegularRule()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradingCalendarRegularRule(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradingCalendarRegularRule(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradingCalendarRegularRuleModel}
   * @param {!number} prev Previous TradingCalendarRegularRule model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradingCalendarRegularRuleModel };
